// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, ProductType, BuiltinType, ProductTypeElement, DatabaseTable, AlgebraicValue, ReducerArgsAdapter, SumTypeVariant, Serializer, Identity, Address, ReducerEvent, Reducer, SpacetimeDBClient } from "@clockworklabs/spacetimedb-sdk";

export class UpdateElementLockedReducer extends Reducer
{
	public static reducerName: string = "UpdateElementLocked";
	public static call(_elementId: number, _locked: boolean) {
		this.getReducer().call(_elementId, _locked);
	}

	public call(_elementId: number, _locked: boolean) {
		const serializer = this.client.getSerializer();
		let _elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		serializer.write(_elementIdType, _elementId);
		let _lockedType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		serializer.write(_lockedType, _locked);
		this.client.call("UpdateElementLocked", serializer);
	}

	public static deserializeArgs(adapter: ReducerArgsAdapter): any[] {
		let elementIdType = AlgebraicType.createPrimitiveType(BuiltinType.Type.U32);
		let elementIdValue = AlgebraicValue.deserialize(elementIdType, adapter.next())
		let elementId = elementIdValue.asNumber();
		let lockedType = AlgebraicType.createPrimitiveType(BuiltinType.Type.Bool);
		let lockedValue = AlgebraicValue.deserialize(lockedType, adapter.next())
		let locked = lockedValue.asBoolean();
		return [elementId, locked];
	}

	public static on(callback: (reducerEvent: ReducerEvent, _elementId: number, _locked: boolean) => void) {
		this.getReducer().on(callback);
	}
	public on(callback: (reducerEvent: ReducerEvent, _elementId: number, _locked: boolean) => void)
	{
		this.client.on("reducer:UpdateElementLocked", callback);
	}
}


export default UpdateElementLockedReducer
